
import React from 'react';
import { BiLike, BiDislike } from 'react-icons/bi';

const Feedback = () => {
  return (
    <div className="text-center my-5">
      <span className="me-3">Did you find this information useful?</span>
      <button className="btn btn-sm text-success">
        <BiLike className="fs-6" />
      </button>
      <button className="btn btn-sm text-danger">
        <BiDislike className="fs-6" />
      </button>
    </div>
  );
};

export default Feedback;
